/* Module-shared API base + axios instance with credentials. */
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Axios instance for admin endpoints. `withCredentials` makes the browser
 * attach the httpOnly `edara_admin` cookie set after POST /api/admin/login.
 * No tokens are stored client-side.
 */
export const adminApi = axios.create({
    baseURL: `${API}/admin`,
    withCredentials: true,
});

/** Returns true on 200, false on 401, throws on other errors. */
export async function isAdminAuthenticated() {
    try {
        const r = await adminApi.get("/me");
        return r.status === 200;
    } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 503) {
            return false;
        }
        throw err;
    }
}

export async function adminLogin(token) {
    return adminApi.post("/login", { token });
}

export async function adminLogout() {
    try {
        await adminApi.post("/logout");
    } catch {
        /* ignore — even on failure, force re-auth on the next request */
    }
}
